import { render, staticRenderFns } from "./PatientStates.vue?vue&type=template&id=133b5f1d&scoped=true&"
import script from "./PatientStates.vue?vue&type=script&lang=js&"
export * from "./PatientStates.vue?vue&type=script&lang=js&"
import style0 from "./PatientStates.vue?vue&type=style&index=0&id=133b5f1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b5f1d",
  null
  
)

export default component.exports